import { StepId } from './steps';

export const BI_STEP_NAME: Record<StepId, string> = {
  [StepId.LandingPage]: 'pod-landing-page',
  [StepId.SelectCategory]: 'pod-select-category',
  [StepId.SelectProducts]: 'pod-select-products',
  [StepId.SelectImage]: 'pod-select-image',
  [StepId.StoreSetup]: 'pod-store-setup',
  [StepId.SelectName]: 'pod-select-name',
  [StepId.StoreReady]: 'pod-store-ready',
  [StepId.PrintfulConnection]: 'pod-printful-connection',
} as const;

export const BI_ACTION_NAME = {
  CONTINUE: 'continue',
  BACK: 'back',
} as const;

export const BI_BUTTON_NAME = {
  DESIGN_SITE: 'design-site',
  MANAGE_PRODUCTS: 'manage-products',
  START_SELLING: 'start-selling',
  OPEN_MOBILE_APP: 'open-mobile-app',
} as const;
